import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCameraClock } from '@fortawesome/pro-regular-svg-icons';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import RoundButton from '../../../../components/RoundButton';
import CandidPhotosModal from './Modal';

const CandidPhotos = ({ buttonClassName }) => {
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <OverlayTrigger
        placement="top"
        overlay={(
          <Popover id="candidPhotos">
            <Popover.Content>
              Configure candid (automatic) photos
            </Popover.Content>
          </Popover>
        )}
      >
        <span className="mr-2">
          <RoundButton className={buttonClassName} onClick={handleOpenModal}>
            <FontAwesomeIcon size="lg" icon={faCameraClock} className="align-middle" />
          </RoundButton>
        </span>
      </OverlayTrigger>

      <CandidPhotosModal show={showModal} onHide={handleCloseModal} />
    </>
  );
};

export default CandidPhotos;
